//export const ENVIRONMENT_CONFIG = "Dev"

export const ENVIRONMENT_CONFIG = "Prod"